/**
 * Convert between timezone-free string representations of times and date
 */
const _ = require('lodash');

const {
  addYears
} = require('date-fns');

module.exports.parseTime = (time
/*: string*/
) =>
/*: Date*/
{
  // 'hh:mm' => Date
  const [h, m] = time.split(':').map(v => parseInt(v, 10));
  const newDate = new Date(0);
  newDate.setHours(h);
  newDate.setMinutes(m);
  return newDate;
}; // Date => 'hh:mm'


module.exports.serializeTime = (date
/*: Date*/
) =>
/*: string*/
{
  const h = _.padStart(date.getHours(), 2, '0');

  const m = _.padStart(date.getMinutes(), 2, '0');

  return `${h}:${m}`;
};

module.exports.parseDate = (date
/*: string*/
) =>
/*: Date | null*/
{
  // 'yyyy-mm-dd' => Date
  if (!date) {
    return null;
  }

  const [y, m, d] = date.split('-').map(v => parseInt(v, 10));
  const newDate = new Date();
  newDate.setHours(0);
  newDate.setMinutes(0);
  newDate.setFullYear(y);
  newDate.setMonth(m - 1);
  newDate.setDate(d);
  return newDate;
};

module.exports.serializeDate = (date
/*: Date*/
) =>
/*: string*/
{
  // Date => 'yyyy-mm-dd'
  const y = date.getFullYear();

  const m = _.padStart(date.getMonth() + 1, 2, '0');

  const d = _.padStart(date.getDate(), 2, '0');

  return `${y}-${m}-${d}`;
}; // '01:05' => 65


const timeToMinute = (time
/*: string*/
) =>
/*: number*/
{
  const [hh, mm] = time.split(':');
  return +hh * 60 + +mm;
};

const endTimeToMinute = (time
/*: string*/
) =>
/*: number*/
timeToMinute(time === '00:00' ? '24:00' : time);

const minuteToTime = (minute
/*: number*/
) =>
/*: string*/
{
  const hh = _.padStart(Math.floor(minute / 60), 2, '0');

  const mm = _.padStart(minute % 60, 2, '0');

  return `${hh === '24' ? '00' : hh}:${mm}`;
};

module.exports.minutesToTimeRanges = (minutes
/*: Array<number>*/
) => _.chain(minutes).sort((a, b) => a - b).reduce((acc, minute) => {
  const last = acc[0];

  if (!last || minute > last[1] + 1) {
    acc.unshift([minute, minute]);
  } else {
    last[1] = minute;
  }

  return acc;
}, []).reverse().map(([from, to]) => [minuteToTime(from), minuteToTime(to + 1)]).value();

module.exports.timeRangesToMinutes = (timeRanges
/*: Array<[string, string]>*/
) => _.chain(timeRanges).map(([from, to]) => [timeToMinute(from), endTimeToMinute(to) - 1]).map(([from, to]) => _.range(from, to + 1)).thru(_.spread(_.union)).value();

module.exports.newScheduleDates = (dateObj = new Date()) => {
  const currentDate = dateObj;
  const yearFromCurrentDate = addYears(dateObj, 1);
  return {
    currentDate,
    yearFromCurrentDate
  };
};